import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiStateCheckbox } from 'primereact/multistatecheckbox';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils';
import { FilterMatchMode } from 'primereact/api';
import { BlockUI } from 'primereact/blockui';

import { useLocalState } from '../../util/useLocalStorage';
import { UsuarioService } from '../../services/Usuario/UsuarioService';
import { BitacoraService } from '../../services/Bitacora/BitacoraService';
import { TraccarService } from '../../services/Traccar/TraccarService';
import { ConfiguracionService } from '../../services/Configuracion/ConfiguracionService';
import { UbicacionesService } from '../../services/Ubicaciones/UbicacionesService';
import { ubicacionesDeViaje } from '../../services/Ubicaciones/ubicacionesDeViaje';
import { BookingService } from '../../services/Booking/BookingService';

const Bitacora = () => {

    let _bitacoraDet = {

        bitacoraDetId: 0,
        activo: true,
        booking: '',
        bookingId: null,
        cablePlug: '',
        conductorCedula: '',
        conductorNombre: '',
        contenedor: '',
        soloChasis: false,
        destinoCodigo: '',
        ubicacion: '',
        ubicacionDestino: {

        },
        destinoNombre: '',
        displey: '',
        dispositivoFechaReporte: '',
        dispositivoIdentificador: '',
        dispositivoNombre: '',
        dispositivoUbicacionLat: '',
        dispositivoUbicacionLon: '',
        estado: '',
        fechaBitacora: '',
        fechaIngreso: '',
        micro: '',
        observacion: '',
        precintoSeguridad: '',
        vehiculoChasis: '',
        vehiculoPlaca: '',
        empresaTransporte: {

        },
        dispositivo: {

        },
        bitacoraCab: {
            "bitacoraCabId": 0,
            "activo": '',
            "estado": '',
            "fecha": '',
            turno: {

            },
            usuario: {

            },
            "bitacoradets": null
        }

    }

    let _ubicacion = {
        ubicacionId: '',
        nombre: '',
        nombreTmp: '',
        codigo: '',
        latitud: '',
        longitud: '',
        area: '',
        estado: 'Activo',
        activo: true,
        tipoUbicacion: {
            nombre: '',
        },
        ubicacionInfoList: [
        ],
        ubicacionTarjetaList: [

        ]


    }

    const options = [
        { value: 'SI', icon: 'pi pi-check' },
        { value: 'NO', icon: 'pi pi-times' },

    ];

    const [blockedDocument, setBlockedDocument] = useState(false);
    const [bloqueadoHastaGuardar, setBloqueadoHastaGuardar] = useState(false);

    const bitacoraService = new BitacoraService();
    const traccarService = new TraccarService();
    const configuracionService = new ConfiguracionService();
    const usuarioService = new UsuarioService();
    const ubicacionesService = new UbicacionesService();
    const bookingService = new BookingService();

    /**Listas */
    const [listaTurno, setListaTurno] = useState(null);
    const [listaBooking, setListaBooking] = useState([]);
    const [listaCandados, setListaCandados] = useState(null);
    const [listaEmpresas, setListaEmpresas] = useState(null);
    const [listaUbicacionDestino, setListaUbicacioneDestino] = useState(null);
    const [listaConductores, setListaConductores] = useState(null);

    // useEffect(() => { ubicacionesService.getListaUbicaciones().then(data => { setUbicacioneDestino(data); }) }, []);



    /**Usuario */
    const [usuario, setUsuario] = useState("");
    const [username, setUsername] = useLocalState("", "username");

    /**Habilitar Botón de Agregar y Buscar */
    const [habilitarBoton, setHabilitarBoton] = useState("");

    /**Habilitar Botón de Asignar */
    const [asignarBoton, setAsignarBoton] = useState(true);

    /**Habilitar Botón de Asignar */
    const [asignarUbicacionDeshabilitar, setAsignarUbicacionDeshabilitar] = useState(true);

    /**Habilitar Dropdown de Ubicaciones/Destinos */
    const [habilitarDropdownUbicaciones, sethabilitarDropdownUbicaciones] = useState(false);

    /**Habilitar Dropdown de Conductores */
    const [habilitarDropdownConductores, sethabilitarDropdownConductores] = useState(false);

    /**Habilitar Dropdown de Booking */
    const [habilitarDropdownBooking, sethabilitarDropdownBooking] = useState(false);

    /**Habilitar Campo de codigoDestino */
    const [habilitarCodigoDestino, setHabilitarCodigoDestino] = useState(true);

    /**Habilitar Campo de nombreDestino */
    const [habilitarNombreDestino, setHabilitarNombreDestino] = useState(true);

    /**Habilitar Campo de nombreConductor */
    const [habilitarNombreConductor, setHabilitarNombreConductor] = useState(true);

    /**Habilitar Campo de cedulaConductor */
    const [habilitarCedulaConductor, setHabilitarCedulaConductor] = useState(true);

    /**Habilitar Campos Fecha y Jornada */
    const [habilitarCampo, setHabilitarCampo] = useState("");

    /**Estilo del campo estadoCandodo */
    const [estiloEstadoCandado, setEstiloEstadoCandado] = useState("");

    /**Formulario - Cabecera */
    const [fecha, setFecha] = useState("");
    const [candado, setCandado] = useState("");

    const [dispositivoId, setDispositivosId] = useState("");
    const [dispositivoNombre, setDispositivoNombre] = useState("");
    const [estadoCandado, setEstadoCandado] = useState("");
    // DOLE tramos a puerto: segundo candado (el del chasis), solo si el booking va en traslado directo
    const [candadoChasis, setCandadoChasis] = useState("");
    const [estadoCandadoChasis, setEstadoCandadoChasis] = useState("");
    const [bateria, setBateria] = useState(0);


    const [contenedores, setContenedores] = useState({});
    const [contenedorDialog, setContenedorDialog] = useState("");
    const [bitacoraDet, setBitacoraDet] = useState(_bitacoraDet);
    const esTrasladoDirecto = !!(bitacoraDet && bitacoraDet.bookingId && bitacoraDet.bookingId.trasladoDirectoUbicacionId);
    const [turno, setTurno] = useState([]);
    const [booking, setBooking] = useState([]);
    const [contenedorSeleccionado, setContenedorSeleccionado] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [backgroundEstadoCandado, setBackgroundEstadoCandado] = useState("");
    const [colorEstadoCandado, setColorEstadoCandado] = useState("");
    const [fechaBitacora, setfechaBitacora] = useState("");
    const [ubicacionDestino, setUbicacionDestino] = useState([]);

    // RF-A9: para el registro retroactivo (LOGISTICA), el ORIGEN (finca/puesto de
    // salida) se elige del maestro; logistica no esta en un puesto, y el motor toma
    // el origen del viaje de la ubicacion del cab -> hay que indicarlo.
    const [origenSeleccionado, setOrigenSeleccionado] = useState(null);
    const [conductor, setConductor] = useState([]);
    const [codigoBooking, setCodigoBooking] = useState("");


    const [deshabilitarBooking, setDeshabilitarBooking] = useState(true);

    const toast = useRef(null);
    const toast2 = useRef(null);

    const dt = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const numeroRegistros = [
        { name: '10', value: 10 },
        { name: 'Todos', value: 0 }

    ];

    const [numeroRegistrosSeleccionadas, setNumeroRegistrosSeleccionadas] = useState(10);

    // RF Registro retroactivo DOLE: el rol LOGISTICA registra emulando al guardia,
    // con fecha/hora del evento EDITABLE (retroactiva) y sin exigir candado en USAR.
    const rolesUsuario = JSON.parse(localStorage.getItem('roles') || '[]');
    const esLogistica = Array.isArray(rolesUsuario) && rolesUsuario.includes('LOGISTICA');
    // DOLE control de tramos (31/10/2026): el guardia de R11 (DEPO11) puede registrar "Retira solo chasis".
    // El booking no se consume y el viaje va de R11 a R9 (DEPO09); en R9 se vuelve a buscar el mismo booking.
    // Solo con el control de tramos encendido (tramos_control_activo, DOL-0000-0000-0032): sin el motor nadie cierra el
    // viaje CHASIS. El backend tambien lo exige.
    const [controlTramosActivo, setControlTramosActivo] = useState(false);
    useEffect(() => {
        configuracionService.getParametrosDole()
            .then((lista) => setControlTramosActivo((lista || []).some((d) => d.codigo === 'DOL-0000-0000-0032'
                && String(d.parametro || '').trim().toLowerCase() === 'true')))
            .catch(() => setControlTramosActivo(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const puedeSoloChasis = controlTramosActivo && (esLogistica || !!(usuario && usuario.ubicacion && usuario.ubicacion.codigo === 'DEPO11'));
    const destinoAntesDeChasis = useRef(null);
    const onChangeSoloChasis = (e) => {
        let _b = { ...bitacoraDet, soloChasis: e.checked };
        if (e.checked) {
            const r9 = listaUbicacionDestino.find((u) => u.codigo === 'DEPO09');
            destinoAntesDeChasis.current = { ubicacionDestino: bitacoraDet.ubicacionDestino, destinoCodigo: bitacoraDet.destinoCodigo, destinoNombre: bitacoraDet.destinoNombre, lista: ubicacionDestino };
            if (r9) {
                setUbicacionDestino(r9);
                _b.ubicacionDestino = r9;
                _b.destinoCodigo = r9.codigo;
                _b.destinoNombre = r9.nombre;
            }
            _b.chasisDispositivoIdentificador = null;
            _b.chasisDispositivoId = null;
        } else if (destinoAntesDeChasis.current) {
            const d = destinoAntesDeChasis.current;
            setUbicacionDestino(d.lista);
            _b.ubicacionDestino = d.ubicacionDestino;
            _b.destinoCodigo = d.destinoCodigo;
            _b.destinoNombre = d.destinoNombre;
            destinoAntesDeChasis.current = null;
        }
        setBitacoraDet(_b);
    };
    const [fechaEvento, setFechaEvento] = useState(new Date());

    /**JWT */
    const [jwt, setJwt] = useLocalState("", "jwt");
    /**Headers Token */
    const config = {
        headers: {
            'Content-Type': "application/json",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: `Bearer ${jwt}`
        }
    }

    useEffect(() => { usuarioService.getUsuario(username).then(data => { setUsuario(data); }); }, []);
    useEffect(() => { configuracionService.getTurno().then(data => setListaTurno(data)); }, []);
    useEffect(() => {
        configuracionService.getListaConductores().then(data => {


            let _conductorList = [];
            data.forEach(d => {
                d.nombreTmp = (d.identificacion + " - " + d.nombre);
                _conductorList.push(d);
            });
            setListaConductores(data);

        });
    }, []);
    // useEffect(() => {

    //     const ADELANTADO = {
    //         bookingId: "-1",
    //         codigo: "ADELANTADO"
    //     };
    //     const EDOPSLRIOS = {
    //         bookingId: "-2",
    //         codigo: "EDOPSLRIOS"
    //     };
    //     const EDOPSGYAS = {
    //         bookingId: "-3",
    //         codigo: "EDOPSGYAS"
    //     };
    //     let _data = listaBooking;

    //     _data.push(ADELANTADO);
    //     _data.push(EDOPSLRIOS);
    //     _data.push(EDOPSGYAS);
    //     setListaBooking(_data);



    // }, []);

    const cargaListaDefaultBooking = () => {
        const ADELANTADO = {
            bookingId: "-1",
            codigo: "ADELANTADO"
        };
        const EDOPSLRIOS = {
            bookingId: "-2",
            codigo: "EDOPSLRIOS",
            fincaCodigo: "PS02"
        };

        const EDOPSGYAS = {
            bookingId: "-3",
            codigo: "EDOPSGYAS",
            fincaCodigo: "PS01"

        };
        const EDOFINCA = {
            bookingId: "-4",
            codigo: "EDOFINCA"
        };
        const EDOPSASO = {
            bookingId: "-5",
            codigo: "EDOPSASO",
            fincaCodigo: "PSASO"

        };
        const EDOPSCOM = {
            bookingId: "-6",
            codigo: "EDOPSCOM",
            fincaCodigo: "PSCOM"

        };
        const EDOPSADEP = {
            bookingId: "-7",
            codigo: "EDOPSADEP",
            fincaCodigo: "PSADEP"

        };
        let _data = [];

        //_data.push(ADELANTADO);
        _data.push(EDOPSLRIOS);
        _data.push(EDOPSGYAS);
        _data.push(EDOPSASO);
        _data.push(EDOPSCOM);
        _data.push(EDOFINCA);
        _data.push(EDOPSADEP);
        setListaBooking(_data);
    }



    useEffect(() => { configuracionService.getListaCandadosPorTipo2().then(data => setListaCandados(data)); }, []);
    useEffect(() => { configuracionService.getListaEmpresas().then(data => { setListaEmpresas(data) }); }, []);

    useEffect(() => {
        ubicacionesService.getListaUbicaciones().then(data => {


            let _ubicacionList = [];
            ubicacionesDeViaje(data).forEach(d => {

                let _ubicacionTmp = { ..._ubicacion };
                _ubicacionTmp.nombreTmp = (d.codigo + "-" + d.nombre);
                _ubicacionTmp.nombre = d.nombre;
                _ubicacionTmp.codigo = d.codigo;
                _ubicacionTmp.ubicacionId = d.ubicacionId;

                _ubicacionList.push(_ubicacionTmp);

            });

            setListaUbicacioneDestino(_ubicacionList);




        })
    }, []);
    useEffect(() => {
        setHabilitarBoton(true);
        setAsignarUbicacionDeshabilitar(true);

    }, []);
    useEffect(() => { setHabilitarCampo(false) }, []);
    useEffect(() => { setEstiloEstadoCandado("") }, []);


    const showSticky = () => {
        toast2.current.show({ severity: 'info', summary: 'Candado Asignado', detail: "Candado Ha sido Asignado", sticky: true });
    };



    const handleSubmitCodigoBooking = (event) => {
        setCodigoBooking(event.target.value);
    };

    const verificarCandadoChasis = () => {
        if (!candadoChasis) {
            showFail("Seleccioná el candado del chasis");
            return;
        }
        setBlockedDocument(true);
        traccarService.consultarEstadoCandado(candadoChasis.identificador).then(data => {
            setEstadoCandadoChasis(data.data.estado);
            setBlockedDocument(false);
        }).catch(() => {
            setBlockedDocument(false);
            showFail("No se pudo verificar el candado del chasis. Intentá de nuevo.");
        });
    }

    const asignarCandadoChasis = () => {
        if (candadoChasis.identificador === bitacoraDet.dispositivoIdentificador) {
            showFail("El candado del chasis tiene que ser distinto al del contenedor");
            return;
        }
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.chasisDispositivoIdentificador = candadoChasis.identificador;
        _bitacoraDet.chasisDispositivoId = candadoChasis.dispositivoId;
        setBitacoraDet(_bitacoraDet);
    }

    const asignarCandado = () => {
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.dispositivoIdentificador = candado.identificador;
        _bitacoraDet.dispositivoNombre = candado.nombre;
        _bitacoraDet.dispositivo = candado;
        setBitacoraDet(_bitacoraDet);
        _bitacoraDet = null;
        showSticky();
    }


    const buscarContenedoresPorUsuarioyFecha = () => {
        setHabilitarCampo(true);
        let _fecha = formatearFecha(fecha);


        if (numeroRegistrosSeleccionadas == 0) {
            bitacoraService.consultarPorUsuarioFechaTurno(usuario.usuarioId, _fecha, turno.configuracionDetId).then(data => {
                if (data.mensaje.codigo.includes('ERR')) {
                    showFail(data.mensaje.codigo + ' - ' + data.mensaje.mensaje);
                } else {
                    setContenedores(data.data);

                    showSuccess(data.mensaje.codigo + ' - ' + data.mensaje.mensaje);
                }
            });

        } else {
            bitacoraService.consultarPorUsuarioFechaTurnoLimit(usuario.usuarioId, _fecha, turno.configuracionDetId, 5).then(data => {
                if (data.mensaje.codigo.includes('ERR')) {
                    showFail(data.mensaje.codigo + ' - ' + data.mensaje.mensaje);
                } else {
                    setContenedores(data.data);

                    showSuccess(data.mensaje.codigo + ' - ' + data.mensaje.mensaje);
                }
            });

        }



    }

    const buscarPorCodigoBooking = () => {

        if (codigoBooking.length < 6) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'El código de booking debe tener al menos 6 dígitos.', life: 3000 });
            return;
        }

        bookingService.getBookingPorEstadoParametro2('Activo',codigoBooking).then(data => {
            const ADELANTADO = {
                bookingId: "-1",
                codigo: "ADELANTADO"
            };
            const EDOPSLRIOS = {
                bookingId: "-2",
                codigo: "EDOPSLRIOS"
            };
            const EDOPSGYAS = {
                bookingId: "-3",
                codigo: "EDOPSGYAS"
            };


            const EDOFINCA = {
                bookingId: "-4",
                codigo: "EDOFINCA"
            };
            const EDOPSASO = {
                bookingId: "-5",
                codigo: "EDOPSASO",
                fincaCodigo: "PSASO"

            };
            const EDOPSCOM = {
                bookingId: "-6",
                codigo: "EDOPSCOM",
                fincaCodigo: "PSCOM"

            };
            const EDOPSADEP = {
                bookingId: "-7",
                codigo: "EDOPSADEP",
                fincaCodigo: "PSADEP"

            };
            let _data = data;

            //_data.push(ADELANTADO);
            _data.push(EDOPSLRIOS);
            _data.push(EDOPSGYAS);
            _data.push(EDOPSASO);
            _data.push(EDOPSCOM);
            _data.push(EDOFINCA);
            _data.push(EDOPSADEP);
            setListaBooking(_data);



        })
    }

    const getEstadoCandado = () => {
        setBlockedDocument(true);
        traccarService.consultarEstadoCandado(candado.identificador).then(data => {
            setDispositivosId(data.data.uniqueid);
            setDispositivoNombre(data.data.uniqueid.name);
            setEstadoCandado(data.data.estado);
            setBateria(data.data.bateria);
            if (data.data.estado === 'USAR') {
                setAsignarBoton(false);
                setBackgroundEstadoCandado("green");
                setColorEstadoCandado("white");
            } else {
                setBackgroundEstadoCandado("red");
                setColorEstadoCandado("white");
                // LOGISTICA (registro retroactivo / a destiempo): el estado actual del
                // candado no importa (el evento ya paso); se muestra pero NO bloquea Asignar.
                setAsignarBoton(!esLogistica);
            }
            setBlockedDocument(false);
        });

    }

    const showErrorNoInternet = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No tiene conexión a internet', life: 3000 });
    }

    const guardar = () => {




        if (bitacoraDet.empresaTransporte == null || Object.keys(bitacoraDet.empresaTransporte).length == 0) {
            showFail("Debe seleccionar una empresa de transporte para guardar");
            return;
        }

        if (bitacoraDet.booking == null || bitacoraDet.booking == "") {
            showFail("Debe seleccionar o crear un booking antes de guardar");
            return;
        }

        if (bitacoraDet.booking == "ADELANTADO") {
            showFail("No puede usar ese codigo de booking, con el nombre ADELANTADO, seleccionar el correcto");
            return;
        }

        if (bitacoraDet.destinoCodigo == null || bitacoraDet.destinoCodigo == "") {
            showFail("Debe seleccionar o crear un codigo de destino antes de guardar");
            return;
        }

        if (bitacoraDet.destinoNombre == null || bitacoraDet.destinoNombre == "") {
            showFail("Debe seleccionar o crear un nombre de destino antes de guardar");
            return;
        }

        if (bitacoraDet.vehiculoPlaca == null || bitacoraDet.vehiculoPlaca == "") {
            showFail("Debe ingresar una placa antes de guardar");
            return;
        }

        if (bitacoraDet.vehiculoChasis == null || bitacoraDet.vehiculoChasis == "") {
            showFail("Debe ingresar chasis de vehiculo antes de guardar");
            return;
        }

        if (bitacoraDet.conductorCedula == null || bitacoraDet.conductorCedula == "") {
            showFail("Debe ingresar cédula del conductor antes de guardar");
            return;
        }

        if (bitacoraDet.conductorNombre == null || bitacoraDet.conductorNombre == "") {
            showFail("Debe ingresar nombre del conductor antes de guardar");
            return;
        }

        if (!bitacoraDet.soloChasis && (bitacoraDet.contenedor == null || bitacoraDet.contenedor == "")) {
            showFail("Debe ingresar contenedor antes de guardar");
            return;
        }
        if (bitacoraDet.soloChasis && !bitacoraDet.bookingId) {
            showFail("Retira solo chasis: busque el booking del vacío que se va a cargar en R9");
            return;
        }
        if (bitacoraDet.soloChasis && (bitacoraDet.contenedor == null || bitacoraDet.contenedor == "")) {
            bitacoraDet.contenedor = 'SOLO CHASIS';
        }
        if (bitacoraDet.soloChasis) {
            // el destino es R9 aunque el booking traiga otra finca (se pudo elegir el booking despues de la casilla)
            const r9 = listaUbicacionDestino.find((u) => u.codigo === 'DEPO09');
            if (!r9) {
                showFail("No se encontró la ubicación R9 (DEPO09) para el retiro de chasis");
                return;
            }
            bitacoraDet.ubicacionDestino = r9;
            bitacoraDet.destinoCodigo = r9.codigo;
            bitacoraDet.destinoNombre = r9.nombre;
        }

        // if (bitacoraDet.precintoSeguridad == null || bitacoraDet.precintoSeguridad == "") {
        //     showFail("Debe ingresar precinto de seguridad antes de guardar");
        //     return;
        // }

        // DOLE tramos a puerto: con traslado directo van dos candados (contenedor y chasis)
        if (esTrasladoDirecto && !bitacoraDet.soloChasis && !bitacoraDet.chasisDispositivoIdentificador) {
            showFail("Este booking va en traslado directo a puerto: asigná también el candado del chasis");
            return;
        }
        if (esTrasladoDirecto && !bitacoraDet.soloChasis && bitacoraDet.chasisDispositivoIdentificador === bitacoraDet.dispositivoIdentificador) {
            showFail("El candado del chasis tiene que ser distinto al del contenedor");
            return;
        }

        if (bitacoraDet.dispositivoIdentificador == null || bitacoraDet.dispositivoIdentificador == "") {
            showFail("Debe asignar un candado antes de guardar")
            return;

        } else {

            setBlockedDocument(true);
            setBloqueadoHastaGuardar(true);
            traccarService.consultarEstadoCandado(bitacoraDet.dispositivoIdentificador).then(data => {

                // LOGISTICA (registro retroactivo) no exige candado en USAR: el evento ya paso.
                if (esLogistica || data.data.estado === 'USAR') {
                    {

                        if (bitacoraDet.bookingId != null && (bitacoraDet.bookingId.codigo == "ADELANTADO" || bitacoraDet.bookingId.codigo == "EDOPSLRIOS" || bitacoraDet.bookingId.codigo == "EDOPSGYAS" || bitacoraDet.bookingId.codigo == "EDOPSASO"  || bitacoraDet.bookingId.codigo == "EDOPSCOM" || bitacoraDet.bookingId.codigo == "EDOPSADEP"
                            || bitacoraDet.bookingId.codigo == "EDOFINCA")) {
                            bitacoraDet.bookingId = null;
                        }
                        // RF-A9: LOGISTICA (retroactivo) indica el ORIGEN (finca/puesto de salida);
                        // el guardia normal usa su propia ubicacion.
                        if (esLogistica) {
                            if (!origenSeleccionado) {
                                setBlockedDocument(false);
                                setBloqueadoHastaGuardar(false);
                                showFail("Seleccioná el puesto / finca de ORIGEN (de salida)");
                                return;
                            }
                            bitacoraDet.ubicacion = origenSeleccionado;
                        } else {
                            bitacoraDet.ubicacion = usuario.ubicacion;
                        }
                        // Para LOGISTICA la fecha del EVENTO es la editable (retroactiva); el
                        // backend la usa como fecha_ingreso y registra fecha_registro=now().
                        if (esLogistica && fechaEvento) {
                            const f = new Date(fechaEvento);
                            const p = (n) => ('0' + n).slice(-2);
                            bitacoraDet.fechaBitacora = `${p(f.getDate())}-${p(f.getMonth() + 1)}-${f.getFullYear()} ${p(f.getHours())}:${p(f.getMinutes())}:${p(f.getSeconds())}`;
                        }
                        let _fecha = formatearFecha(esLogistica ? fechaEvento : fecha);
                        bitacoraDet.bitacoraCab.fecha = _fecha;
                        bitacoraDet.bitacoraCab.activo = true;
                        bitacoraDet.activo = true;
                        bitacoraDet.bitacoraCab.estado = "Activo";
                        bitacoraDet.bitacoraCab.turno = turno;
                        bitacoraDet.bitacoraCab.usuario = usuario;
                        bitacoraDet.estado = "Activo";

                        //  bitacoraDet.destinoCodigo = bitacoraDet.ubicacionDestino.codigo;
                        // bitacoraDet.destinoNombre = bitacoraDet.ubicacionDestino.nombre;

                        var condition = navigator.onLine ? 'online' : 'offline';
                        if (condition === 'online') {
                            console.log('ONLINE');
                            fetch('https://www.google.com/', { // Check for internet connectivity
                                mode: 'no-cors',
                            })
                                .then(() => {
                                    console.log('CONNECTED TO INTERNET');
                                    bitacoraService.guardar(usuario.usuarioId, bitacoraDet).then(() => {
                                        setBlockedDocument(false);
                                        setBloqueadoHastaGuardar(false);
                                        showSuccess();
                                        hideDialog();
                                    }).catch(() => {
                                        // no dejar el boton trabado si el grabado falla
                                        setBlockedDocument(false);
                                        setBloqueadoHastaGuardar(false);
                                        showFail("No se pudo guardar la bitácora. Intentá de nuevo.");
                                    });


                                }).catch(() => {
                                    setBlockedDocument(false);
                                    setBloqueadoHastaGuardar(false);
                                    console.log('INTERNET CONNECTIVITY ISSUE');
                                    showErrorNoInternet();
                                })
                        } else {
                            setBlockedDocument(false);
                            setBloqueadoHastaGuardar(false);
                            showErrorNoInternet();
                            console.log('OFFLINE')
                        }

                    }

                    limpiarBooking();
                    limpiarConductor();
                    limpiarUbicacion();
                } else {
                    setBlockedDocument(false);
                    setBloqueadoHastaGuardar(false);
                    setBackgroundEstadoCandado("red");
                    setColorEstadoCandado("white");
                    setAsignarBoton(true);
                    showFail("No se puede grabar, candado no se puede usar")
                    return;
                }

            }).catch(() => {
                // no dejar el boton trabado si falla el chequeo del candado (Traccar)
                setBlockedDocument(false);
                setBloqueadoHastaGuardar(false);
                showFail("No se pudo verificar el candado (Traccar). Intentá de nuevo.");
            });

        }


    }

    const onChangeFecha = (e) => {
        setFecha(e.value);
        if (turno.length !== 0)
            setHabilitarBoton(false);
        else
            setHabilitarBoton(true);
    }

    const onChangeTurno = (e) => {
        setTurno(e.value);
        if (fecha !== null && fecha !== "")
            setHabilitarBoton(false);
        else
            setHabilitarBoton(true);
    }

    // const onChangeBooking = (e) => {
    //     const _bitacoraDet = { ...bitacoraDet }
    //     _bitacoraDet.booking = e.value.codigo;
    //     setBitacoraDet(_bitacoraDet);
    //     setBooking(e.value);

    // }

    const onBookingChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet[`${name}`] = val;

        if (e.value == undefined) {
            _bitacoraDet.booking = null;
        } else {
            _bitacoraDet.booking = e.value.codigo;

        }
        setBitacoraDet(_bitacoraDet);
    }

    const onChangeEstadoCandado = (e) => {
        setEstadoCandado(e.value);
    }

    const onChangeCandadoSeleccionado = (e) => {
        setCandado(e.target.value);
        setEstadoCandado("");
        setBackgroundEstadoCandado("");
        setColorEstadoCandado("");
        // LOGISTICA (registro retroactivo) puede asignar sin verificar estado USAR:
        // el evento ya paso, el candado hoy puede no estar en USAR.
        setAsignarBoton(!esLogistica);
    }

    const onChangeBooking = (e) => {

        setBooking(e.target.value);
        setUbicacionDestino(null);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.booking = '';
        _bitacoraDet['bookingId'] = null;
        _bitacoraDet.destinoCodigo = "";
        _bitacoraDet.destinoNombre = "";
        _bitacoraDet.ubicacionDestino = null;
        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(true);
        setAsignarUbicacionDeshabilitar(true);
    }


    const asignarBooking = (e) => {
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.booking = booking.codigo;
        _bitacoraDet['bookingId'] = booking;

        setDeshabilitarBooking(true);
        setAsignarUbicacionDeshabilitar(true);


        // el feed de bookings a veces trae la finca sin el prefijo 'EC' del catalogo
        // (ej. booking '3407' vs ubicacion 'EC3407'). Si el match exacto falla, reintentar con 'EC'+codigo.
        let _ubicacionDestino = listaUbicacionDestino.find((obj) => obj.codigo === booking.fincaCodigo);
        if (_ubicacionDestino == null && booking.fincaCodigo) {
            _ubicacionDestino = listaUbicacionDestino.find((obj) => obj.codigo === 'EC' + booking.fincaCodigo);
        }

        if (_ubicacionDestino != null && (usuario.ubicacion ? usuario.ubicacion.codigo : null) != booking.fincaCodigo) {
            setUbicacionDestino(_ubicacionDestino);

            _bitacoraDet.ubicacionDestino = _ubicacionDestino;
            _bitacoraDet.destinoCodigo = _ubicacionDestino.codigo;
            _bitacoraDet.destinoNombre = _ubicacionDestino.nombre;
            setBitacoraDet(_bitacoraDet);


        }

        if (booking.codigo == 'EDOFINCA' || !booking.fincaCodigo) {
            setAsignarUbicacionDeshabilitar(false);
        }

        if (booking.fincaCodigo && (usuario.ubicacion ? usuario.ubicacion.codigo : null) == booking.fincaCodigo && booking.fincaCodigoFinal) {




            let _ubicacionDestino = listaUbicacionDestino.find((obj) => obj.codigo === booking.fincaCodigoFinal);
            if (_ubicacionDestino == null && booking.fincaCodigoFinal) {
                _ubicacionDestino = listaUbicacionDestino.find((obj) => obj.codigo === 'EC' + booking.fincaCodigoFinal);
            }

            if (_ubicacionDestino != null) {
                setUbicacionDestino(_ubicacionDestino);

                _bitacoraDet.ubicacionDestino = _ubicacionDestino;
                _bitacoraDet.destinoCodigo = _ubicacionDestino.codigo;
                _bitacoraDet.destinoNombre = _ubicacionDestino.nombre;
                setBitacoraDet(_bitacoraDet);


            }

        }

        setBitacoraDet(_bitacoraDet);

    };



    const crearBooking = (e) => {
        sethabilitarDropdownBooking(true);
        setBooking(null);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.booking = '';
        _bitacoraDet['bookingId'] = null;
        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(false);
    };

    const limpiarBooking = (e) => {

        setBooking(null);
        setUbicacionDestino(null);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.booking = '';
        _bitacoraDet['bookingId'] = null;
        _bitacoraDet.destinoCodigo = "";
        _bitacoraDet.destinoNombre = "";
        _bitacoraDet.ubicacionDestino = null;
        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(true);
        sethabilitarDropdownBooking(false);
        cargaListaDefaultBooking();
        setCodigoBooking("");


    };


    const onChangeUbicacion = (e) => {

        setUbicacionDestino(e.target.value);

        let _bitacoraDet = { ...bitacoraDet };

        _bitacoraDet.destinoCodigo = "";
        _bitacoraDet.destinoNombre = "";
        _bitacoraDet.ubicacionDestino = e.target.value;


        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(true);
        // habilitar el boton Asignar del destino al elegir una ubicacion a mano:
        // si el booking no precargo la finca (no estaba en la lista), este dropdown
        // manual es el unico camino para setear el destino. Se deshabilita al limpiar.
        setAsignarUbicacionDeshabilitar(e.target.value == null);

    }

    const onChangeConductor = (e) => {

        setConductor(e.target.value);


        let _bitacoraDet = { ...bitacoraDet };

        _bitacoraDet.conductorNombre = "";
        _bitacoraDet.conductorCedula = "";
        _bitacoraDet.conductor = e.target.value;



        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(true);

    }


    const asignarUbicacion = (e) => {

        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.destinoCodigo = _bitacoraDet.ubicacionDestino.codigo;
        _bitacoraDet.destinoNombre = _bitacoraDet.ubicacionDestino.nombre;

        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(true);
    };

    const crearUbicacion = (e) => {

        setUbicacionDestino(null);
        sethabilitarDropdownUbicaciones(true);
        setHabilitarCodigoDestino(false);
        setHabilitarNombreDestino(false);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.ubicacionDestino = null;
        _bitacoraDet.destinoCodigo = "";
        _bitacoraDet.destinoNombre = "";

        setBitacoraDet(_bitacoraDet);


    };

    const limpiarUbicacion = (e) => {
        sethabilitarDropdownUbicaciones(false);
        setHabilitarCodigoDestino(true);
        setHabilitarNombreDestino(true);
        setUbicacionDestino(null);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.destinoCodigo = "";
        _bitacoraDet.destinoNombre = "";
        setBitacoraDet(_bitacoraDet);
        setDeshabilitarBooking(true);
    };

    const asignarConductor = (e) => {
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.conductor = conductor;
        _bitacoraDet.conductorNombre = conductor.nombre;
        _bitacoraDet.conductorCedula = conductor.identificacion;

        setBitacoraDet(_bitacoraDet);


    };

    const crearConductor = (e) => {

        setConductor(null);
        sethabilitarDropdownConductores(true);
        setHabilitarNombreConductor(false);
        setHabilitarCedulaConductor(false);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.conductor = null;
        _bitacoraDet.conductorNombre = "";
        _bitacoraDet.conductorCedula = "";

        setBitacoraDet(_bitacoraDet);


    };

    const limpiarConductor = (e) => {
        sethabilitarDropdownConductores(false);
        setHabilitarNombreConductor(true);
        setHabilitarCedulaConductor(true);
        setConductor(null);
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet.conductor = null;
        _bitacoraDet.conductorNombre = "";
        _bitacoraDet.conductorCedula = "";
        setBitacoraDet(_bitacoraDet);
    };


    const formatearFecha = (fecha, formato = 'dd-mm-yyyy') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {
            case 'dd-mm-yyyy': return [day, month, year].join('-');
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');

        }
    }

    const openNew = () => {
        setHabilitarCampo(true);
        setBitacoraDet(_bitacoraDet);
        setCandado("");

        //let _fecha = formatearFecha(fecha);
        let today = new Date();
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let _fecha = formatearFecha(today);
        let dateTime = _fecha + ' ' + time;
        _bitacoraDet.fechaBitacora = dateTime;
        setFechaEvento(today);   // LOGISTICA puede cambiarla a la fecha real del evento
        setOrigenSeleccionado(null); // RF-A9: origen del registro retroactivo (LOGISTICA)
        setEstadoCandado("");
        setCandadoChasis("");
        setEstadoCandadoChasis("");
        setSubmitted(false);
        cargaListaDefaultBooking();
        setContenedorDialog(true);
    }

    const limpiar = () => {
        setFecha("");
        setTurno("");
        setBitacoraDet(_bitacoraDet);
        setCandado("");
        setEstadoCandado("");
        setContenedores([]);
        setHabilitarBoton(true);
        setHabilitarCampo(false);
    }

    const hideDialog = () => {

        setDispositivosId("");
        setDispositivoNombre("");
        setBooking("");
        setUbicacionDestino("");
        setConductor("");
        setHabilitarBoton(false);
        setHabilitarCampo(false);
        setSubmitted(false);
        setContenedorDialog(false);
        setBackgroundEstadoCandado("");
        setColorEstadoCandado("");
        setAsignarBoton(true);
        setBitacoraDet(_bitacoraDet);
        setCodigoBooking("");


    }

    const editProduct = (bitacoraDet) => {

        let _bitacoraDet = { ...bitacoraDet };
        let _ubicacionTmp = _bitacoraDet.ubicacionDestino;

        if (_ubicacionTmp != null) {

            _ubicacionTmp.nombreTmp = (_ubicacionTmp.codigo + "-" + _ubicacionTmp.nombre);
            _bitacoraDet.ubicacionDestino = _ubicacionTmp;
        } else {
            _bitacoraDet.ubicacionDestino = "";
        }

        setBitacoraDet(_bitacoraDet);


        setContenedorDialog(true);
    }

    const onInputChange = (e, name) => {

        if (name == 'empresaTransporte' || name == 'displey' || name == 'cablePlug' || name == 'micro' || name == 'ubicacionDestino') {
            const val = (e.target && e.target.value) || '';
            let _bitacoraDet = { ...bitacoraDet };
            _bitacoraDet[`${name}`] = val;
            setBitacoraDet(_bitacoraDet);
        } else {
            const val = (e.target && e.target.value.toUpperCase()) || '';
            let _bitacoraDet = { ...bitacoraDet };
            _bitacoraDet[`${name}`] = val;
            setBitacoraDet(_bitacoraDet);
        }
    }

    const onUbicacionDestinoChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet[`${name}`] = val;
        _bitacoraDet.destinoCodigo = val.codigo;
        _bitacoraDet.destinoNombre = val.nombre;
        setBitacoraDet(_bitacoraDet);
    }

    const onChangeContenedorSeleccionado = (e) => {
        setContenedorSeleccionado(e.value);
    }

    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: 'Success Message', detail: message, life: 3000 });
    }

    const showFail = (message) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
            </React.Fragment>
        );
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" value={globalFilterValue} onInput={onGlobalFilterChange} placeholder="Buscar Bitacora" />
            </span>
        </div>
    );

    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" disabled={bloqueadoHastaGuardar} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" disabled={bloqueadoHastaGuardar} icon="pi pi-check" className="p-button-text" onClick={guardar} />
        </React.Fragment>
    );

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    return (
        <div className="grid">
            <div className="col-12">
                <BlockUI blocked={blockedDocument} fullScreen />
                <Toast ref={toast2} />
                <div className="card p-fluid">
                    <h5>Control de Contenedores</h5>
                    <div className="formgrid grid">
                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="icon">Fecha</label>
                            <Calendar id="icon" value={fecha} disabled={habilitarCampo} onChange={onChangeFecha} showIcon dateFormat="dd/mm/yy" />
                        </div>
                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="turno">Turno</label>
                            <Dropdown id="turno" value={turno} optionLabel="nombre" disabled={habilitarCampo} options={listaTurno} onChange={onChangeTurno} placeholder="Seleccionar"></Dropdown>
                        </div>


                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">

                            <label htmlFor="numeroRegistros" className='mb-3'>Número de Registros</label>
                            <div className="p-inputgroup">
                                <Dropdown id='numeroRegistros' optionLabel="name" options={numeroRegistros} value={numeroRegistrosSeleccionadas}
                                    onChange={(e) => setNumeroRegistrosSeleccionadas(e.value)} placeholder="Selecciona número de Registros" filter className="w-8 md:w-10rem" />
                            </div>

                        </div>





                        <div className="field col-6 md:col-4 lg:col-2 sm:col-6">
                            <label htmlFor="buscar">&nbsp;</label>
                            <Button id="buscar" label="Buscar" disabled={habilitarBoton} onClick={buscarContenedoresPorUsuarioyFecha} className="p-button-success p-button-raised   " icon="pi pi-search" iconPos="right" />
                        </div>
                        <div className="field col-6 md:col-4 lg:col-2 sm:col-6">
                            <label htmlFor="nuevo">&nbsp;</label>
                            <Button id="nuevo" label="Agregar" disabled={habilitarBoton} className="p-button-raised" icon="pi pi-plus" iconPos="right" onClick={openNew} />
                        </div>
                        <div className="field col-12 md:col-4 lg:col-2 sm:col-12">
                            <label htmlFor="limpiar">&nbsp;</label>
                            <Button id="limpiar" label="Limpiar" className="p-button-help p-button-raised" icon="pi pi-replay" iconPos="right" onClick={limpiar} />
                        </div>
                    </div>
                </div>

                <div className="card p-fluid">
                    <h5>Lista de Contenedores</h5>
                    <div className="col-12">
                        <Toast ref={toast} />
                        <div className="card">
                            <DataTable ref={dt} paginator rows={5} rowsPerPageOptions={[5, 10]} scrollable scrollHeight="400px" value={contenedores.bitacoradets} selection={contenedorSeleccionado} onSelectionChange={onChangeContenedorSeleccionado}
                                dataKey="bitacoraDetsId" filters={filters} filterDisplay="row"
                                globalFilterFields={['booking']} header={header} responsiveLayout="scroll"
                                sortField="fechaIngreso" sortOrder={-1} >
                                <Column field="fechaIngreso" header="Fecha Ingreso" style={{ minWidth: '12rem' }}></Column>
                                <Column field="booking" header="Booking" style={{ minWidth: '12rem' }}></Column>
                                <Column field="contenedor" header="Contenedor" style={{ minWidth: '12rem' }}></Column>
                                <Column field="destinoCodigo" header="Destino" style={{ minWidth: '12rem' }}></Column>
                                <Column field="vehiculoPlaca" header="Placa del Vehiculo" style={{ minWidth: '12rem' }}></Column>
                                <Column field="dispositivoNombre" header="Dispositivo" style={{ minWidth: '12rem' }}></Column>
                                <Column field="empresaTransporte.nombre" header="Empresa" style={{ minWidth: '12rem' }}></Column>
                                <Column field="conductorNombre" header="Nombre Conductor" style={{ minWidth: '12rem' }}></Column>
                                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>


            <Dialog visible={contenedorDialog} closable={false} style={{ width: '90vw' }} header="Detalles del Contenedor" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>

                <div className="col-12">
                    <div className="card p-fluid">
                        <h5>Candado</h5>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="candadoList">Candado</label>
                                <div className="p-inputgroup">
                                    <Dropdown id='candadoList' options={listaCandados} optionLabel="nombre" value={candado} onChange={onChangeCandadoSeleccionado} placeholder="Selecciona un candado"
                                        filter className="w-full md:w-14rem" />
                                    <Button label='Verificar Candado' onClick={getEstadoCandado} onChange={onChangeEstadoCandado} className="p-button-warning" />
                                </div>
                            </div>
                            <div className="field col" >
                                <label htmlFor="estadoCandado">Estado Candado</label>
                                <div className="p-inputgroup" >
                                    <InputText id="estadoCandado" style={{ backgroundColor: backgroundEstadoCandado, color: colorEstadoCandado, opacity: 1 }} value={estadoCandado} onChange={(e) => setEstadoCandado(e.value)} type="text" disabled className={estiloEstadoCandado} />
                                    <Button id="asignar" label="Asignar" className="p-button-secundary ml-2" disabled={asignarBoton} onClick={asignarCandado} iconPos="right" />
                                </div>
                            </div>
                        </div>
                        <div className='formgrid grid'>
                            <div className="field col" >
                                <label htmlFor="dispositivoId">Dispositivo Asignado </label>
                                <div className="p-inputgroup" >
                                    <InputText id="dispositivoId" className="opacity-100" value={bitacoraDet.dispositivoIdentificador} onChange={e => setDispositivosId(e.target.value)} type="text" disabled placeholder='No dispositivo asignado' />
                                    <InputText id="dispositivoNombre" className="opacity-100" value={bitacoraDet.dispositivoNombre} onChange={e => setDispositivoNombre(e.target.value)} type="text" disabled placeholder='No dispositivo asignado' />
                                </div>
                            </div>
                        </div>
                    </div>

                    {esTrasladoDirecto && !bitacoraDet.soloChasis && (
                        <div className="card p-fluid" id="candadoChasisCard">
                            <h5>Candado del chasis (traslado directo a puerto)</h5>
                            <div className="formgrid grid">
                                <div className="field col">
                                    <label htmlFor="candadoChasisList">Candado del chasis</label>
                                    <div className="p-inputgroup">
                                        <Dropdown id='candadoChasisList' options={listaCandados} optionLabel="nombre" value={candadoChasis}
                                            onChange={(e) => { setCandadoChasis(e.value); setEstadoCandadoChasis(""); }}
                                            placeholder="Selecciona el candado del chasis" filter className="w-full md:w-14rem" />
                                        <Button label='Verificar' onClick={verificarCandadoChasis} className="p-button-warning" />
                                    </div>
                                </div>
                                <div className="field col">
                                    <label htmlFor="estadoCandadoChasis">Estado</label>
                                    <div className="p-inputgroup">
                                        <InputText id="estadoCandadoChasis" value={estadoCandadoChasis} disabled
                                            style={{ backgroundColor: estadoCandadoChasis === 'USAR' ? 'green' : (estadoCandadoChasis ? 'red' : ''), color: estadoCandadoChasis ? 'white' : '', opacity: 1 }} />
                                        <Button id="asignarChasis" label="Asignar" className="p-button-secundary ml-2"
                                            disabled={!candadoChasis || (!esLogistica && estadoCandadoChasis !== 'USAR')} onClick={asignarCandadoChasis} />
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <label htmlFor="chasisAsignado">Candado del chasis asignado</label>
                                <InputText id="chasisAsignado" className="opacity-100" value={bitacoraDet.chasisDispositivoIdentificador || ''} disabled placeholder='Sin candado de chasis' />
                            </div>
                        </div>
                    )}

                    <div className="card p-fluid">
                        <h5>Contenedor</h5>
                        <div className="field">
                            <label htmlFor="fechaYHoraBitacora">Fecha y Hora de la Bitacora</label>
                            {esLogistica ? (
                                <>
                                    <Calendar id="fechaYHoraBitacora" value={fechaEvento} onChange={(e) => setFechaEvento(e.value)}
                                        showTime showSeconds hourFormat="24" dateFormat="dd/mm/yy" showIcon />
                                    <small>Registro retroactivo (LOGISTICA): cargá la fecha/hora REAL del evento. Queda auditada la fecha de registro.</small>
                                </>
                            ) : (
                                <InputText type="text" disabled style={{ opacity: 1 }} name="fechaBitacora" id="fechaYHoraBitacora" value={bitacoraDet.fechaBitacora} onChange={(e) => onInputChange(e, 'fechaBitacora')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.fechaBitacora })} />
                            )}
                        </div>

                        {puedeSoloChasis && (
                            <div className="field-checkbox">
                                <Checkbox inputId="soloChasis" checked={!!bitacoraDet.soloChasis} onChange={onChangeSoloChasis} />
                                <label htmlFor="soloChasis"><b>Retira solo chasis</b> (R11 → R9): el candado va en el chasis, no se pide contenedor y el booking no se consume</label>
                            </div>
                        )}
                        <div className="field">
                            <label htmlFor="contenedor">Contenedor{bitacoraDet.soloChasis ? ' (no aplica: retira solo chasis)' : ''}</label>
                            <InputText type="text" name="contenedor" id="booking" value={bitacoraDet.contenedor} onChange={(e) => onInputChange(e, 'contenedor')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.contenedor })} />
                            {submitted && !bitacoraDet.contenedor && <small className="p-error">Contenedor is required.</small>}

                        </div>

                    </div>

                    <div className="card p-fluid">
                        <h5>Booking</h5>
                        <div className="formgrid grid">
                            <div className="field col-3">
                                <label>Booking a buscar </label>
                                <div className="p-inputgroup">
                                    <InputText value={codigoBooking} placeholder='6 Dígitos Mínimos' onChange={handleSubmitCodigoBooking} />
                                    <Button icon="pi pi-search" className="p-button-warning" onClick={buscarPorCodigoBooking} />
                                </div>
                            </div>
                            <div className="field col-3">
                                <label htmlFor="listaBooking">Listada de Bookings</label>
                                <Dropdown
                                    id="listaBooking"
                                    dataKey='bookingId'
                                    value={booking}
                                    optionLabel="codigo"
                                    options={listaBooking}
                                    onChange={onChangeBooking}
                                    showFilterClear
                                    placeholder="Seleccionar Booking"
                                    filter
                                    showClear
                                    className="w-full"
                                    disabled={habilitarDropdownBooking}
                                ></Dropdown>
                            </div>
                            <div className="field col-2">
                                <label htmlFor="asignarBooking">&nbsp;</label>
                                <Button id="asignarBooking" label="Asignar" className="p-button-raised" disabled={asignarBoton} onClick={asignarBooking} iconPos="right" icon="pi pi-check" />
                            </div>

                            {/*<div className="field col-2">
                                <label htmlFor="crearBooking">&nbsp;</label>
                                <Button id="crearBooking" label="Crear" className="p-button-help p-button-raised" disabled={asignarBoton} onClick={crearBooking} iconPos="right" icon="pi pi-plus" />
                            </div>*/}

                            <div className="field col-2">
                                <label htmlFor="limpiarBooking">&nbsp;</label>
                                <Button id="limpiarBooking" label="Limpiar" className="p-button-warning p-button-raised" disabled={asignarBoton} onClick={limpiarBooking} iconPos="right" icon="pi pi-eraser" />
                            </div>


                        </div>

                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="booking">Booking Asignado</label>

                                <InputText type="text" name="booking" id="booking" value={bitacoraDet.booking} onChange={(e) => onInputChange(e, 'booking')} required
                                    className={classNames({ 'p-invalid': submitted && !bitacoraDet.booking })} disabled={deshabilitarBooking} />
                                {submitted && !bitacoraDet.booking && <small className="p-error">Booking is required.</small>}

                            </div>
                        </div>
                    </div>

                    {esLogistica && (
                        <div className="card p-fluid">
                            <h5>Origen (registro retroactivo)</h5>
                            <div className="formgrid grid">
                                <div className="field col-6">
                                    <label htmlFor="ubicacionOrigen">Finca / puesto de salida</label>
                                    <Dropdown id="ubicacionOrigen" dataKey="ubicacionId" options={listaUbicacionDestino}
                                        optionLabel="nombreTmp" value={origenSeleccionado}
                                        onChange={(e) => setOrigenSeleccionado(e.value)}
                                        placeholder="Seleccionar origen" filter showClear className="w-full" />
                                    <small>Logística registra por el guardia: indicá desde qué finca/puesto <b>salió</b> el
                                        contenedor. Define el <b>origen</b> del viaje (el sistema no lo puede deducir solo).</small>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="card p-fluid">
                        <h5>Destino</h5>
                        <div className="formgrid grid">
                            <div className="field col-6">
                                <label htmlFor="ubicacionDestino">Lista de Ubicaciones</label>
                                <Dropdown
                                    id='ubicacionDestino'
                                    dataKey='ubicacionId'
                                    options={listaUbicacionDestino}
                                    optionLabel="nombreTmp"
                                    value={ubicacionDestino}
                                    onChange={onChangeUbicacion}
                                    placeholder="Seleccionar Ubicación"
                                    filter
                                    showClear
                                    className="w-full"
                                    disabled={habilitarDropdownUbicaciones}
                                />


                            </div>
                            <div className="field col-2">
                                <label htmlFor="asignarUbicacion">&nbsp;</label>
                                <Button id="asignarUbicacion" label="Asignar" className="p-button-raised" disabled={asignarUbicacionDeshabilitar} onClick={asignarUbicacion} iconPos="right" icon="pi pi-check" />
                            </div>

                            {/*<div className="field col-2">
                                <label htmlFor="crearUbicacion">&nbsp;</label>
                                <Button id="crearUbicacion" label="Crear" className="p-button-help p-button-raised" disabled={asignarBoton} onClick={crearUbicacion} iconPos="right" icon="pi pi-plus" />
                            </div>*/}

                            <div className="field col-2">
                                <label htmlFor="limpiarUbicacion">&nbsp;</label>
                                <Button id="limpiarUbicacion" label="Limpiar" className="p-button-warning p-button-raised" disabled={asignarBoton} onClick={limpiarUbicacion} iconPos="right" icon="pi pi-eraser" />
                            </div>
                        </div>
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="destinoCodigo">Destino</label>
                                <div className="p-inputgroup " >
                                    <InputText type="text" name="destinoCodigo" disabled={habilitarCodigoDestino} placeholder='destinoCodigo' id="destinoCodigo" value={bitacoraDet.destinoCodigo} onChange={(e) => onInputChange(e, 'destinoCodigo')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.destinoCodigo })} />
                                    {submitted && !bitacoraDet.destinoCodigo && <small className="p-error">DestinoCodigo is required.</small>}
                                    <InputText id="finca" placeholder='destinoNombre' disabled={habilitarNombreDestino} value={bitacoraDet.destinoNombre} onChange={(e) => onInputChange(e, 'destinoNombre')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.destinoNombre })} />
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="card p-fluid">
                        <h5>Vehiculo</h5>
                        <div className="field">
                            <label htmlFor="placa">Placa</label>
                            <InputText id="placa" name='vehiculoPlaca' value={bitacoraDet.vehiculoPlaca} onChange={(e) => onInputChange(e, 'vehiculoPlaca')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.vehiculoPlaca })} />
                        </div>
                        <div className="field">
                            <label htmlFor="chasis">Chasis</label>
                            <InputText id="chasis" value={bitacoraDet.vehiculoChasis} onChange={(e) => onInputChange(e, 'vehiculoChasis')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.vehiculoChasis })} />
                        </div>

                    </div>

                    <div className="card p-fluid">
                        <h5>Conductor</h5>

                        <div className="formgrid grid">
                            <div className="field col-6">
                                <label htmlFor="conductores">Lista de Conductores</label>
                                <Dropdown
                                    id='conductores'
                                    dataKey='personaId'
                                    options={listaConductores}
                                    optionLabel="nombreTmp"
                                    value={conductor}
                                    onChange={onChangeConductor}
                                    placeholder="Seleccionar Conductor"
                                    filter
                                    showClear
                                    className="w-full"
                                    disabled={habilitarDropdownConductores}
                                />


                            </div>
                            <div className="field col-2">
                                <label htmlFor="asignarConductor">&nbsp;</label>
                                <Button id="asignarConductor" label="Asignar" className="p-button-raised" disabled={asignarBoton} onClick={asignarConductor} iconPos="right" icon="pi pi-check" />
                            </div>

                            <div className="field col-2">
                                <label htmlFor="crearConductor">&nbsp;</label>
                                <Button id="crearConductor" label="Crear" className="p-button-help p-button-raised" disabled={asignarBoton} onClick={crearConductor} iconPos="right" icon="pi pi-plus" />
                            </div>

                            <div className="field col-2">
                                <label htmlFor="limpiarConductor">&nbsp;</label>
                                <Button id="limpiarConductor" label="Limpiar" className="p-button-warning p-button-raised" disabled={asignarBoton} onClick={limpiarConductor} iconPos="right" icon="pi pi-eraser" />
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor="nombreConductor">Nombre</label>
                            <InputText id="nombreConductor" type="text" disabled={habilitarNombreConductor} value={bitacoraDet.conductorNombre} onChange={(e) => onInputChange(e, 'conductorNombre')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.conductorNombre })} />
                        </div>
                        <div className="field">
                            <label htmlFor="cedulaConductor">Cédula</label>
                            <InputText id="cedulaConductor" value={bitacoraDet.conductorCedula} disabled={habilitarCedulaConductor} onChange={(e) => onInputChange(e, 'conductorCedula')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.conductorCedula })} />
                        </div>
                        <div className="field">
                            <label htmlFor="empresaConductor">Empresa</label>
                            <div className="p-inputgroup">
                                <Dropdown id='empresaConductor' options={listaEmpresas} optionLabel="nombre" value={bitacoraDet.empresaTransporte} onChange={(e) => onInputChange(e, 'empresaTransporte')} placeholder="Selecciona una empresa"
                                    filter className="w-full md:w-14rem" required />
                            </div>
                        </div>
                    </div>

                    <div className="card p-fluid">
                        <h5>Validaciones de Seguridad</h5>
                        <div className="formgrid grid">
                            {/* <div className="field col">
                                <div className="card flex flex-column align-items-center gap-3">
                                    <label htmlFor="display">Display</label>
                                    <MultiStateCheckbox id="display" value={bitacoraDet.displey} onChange={(e) => onInputChange(e, 'displey')} options={options} optionValue="value" />
                                    <span></span>
                                </div>
                            </div>
                            <div className="field col">
                                <div className="card flex flex-column align-items-center gap-3">
                                    <label htmlFor="cableYPlug">Cable y Plug</label>
                                    <MultiStateCheckbox id="cableYPlug" options={options} optionValue="value" value={bitacoraDet.cablePlug} onChange={(e) => onInputChange(e, 'cablePlug')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.cablePlug })} />
                                    <span></span>
                                </div>
                            </div>
                            <div className="field col">
                                <div className="card flex flex-column align-items-center gap-3">
                                    <label htmlFor="micro">Micro</label>
                                    <MultiStateCheckbox id="micro" options={options} optionValue="value" value={bitacoraDet.micro} onChange={(e) => onInputChange(e, 'micro')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.micro })} />
                                    <span></span>
                                </div>
                            </div> */}
                        </div>
                        <div className="field">
                            <label htmlFor="precintoSeguridad">Precinto Seguridad</label>
                            <InputText id="precintoSeguridad" value={bitacoraDet.precintoSeguridad} onChange={(e) => onInputChange(e, 'precintoSeguridad')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.precintoSeguridad })} />
                        </div>
                    </div>
                    <div className="card p-fluid">
                        <h5>Observacion</h5>
                        <div className="field">
                            <label htmlFor="observacion">Observacion</label>
                            <InputText id="observacion" type="text" value={bitacoraDet.observacion} onChange={(e) => onInputChange(e, 'observacion')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.observacion })} />
                        </div>
                    </div>
                </div>
            </Dialog>
        </div >
    );
};

export default Bitacora;
